import { Injectable, WritableSignal, signal } from '@angular/core';

export type ToastType = 'info' | 'success' | 'error';

export interface ToastMessage {
  id: number;
  message: string;
  type: ToastType;
  timeoutId?: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly messages: WritableSignal<ToastMessage[]> = signal([]);
  private counter = 0;
  private readonly isBrowser = typeof window !== 'undefined';

  readonly toasts = this.messages.asReadonly();

  show(message: string, type: ToastType = 'info', options?: { duration?: number }): void {
    const id = ++this.counter;
    const duration = options?.duration ?? 5000;
    const toast: ToastMessage = { id, message, type };

    if (duration > 0 && this.isBrowser) {
      toast.timeoutId = window.setTimeout(() => this.dismiss(id), duration);
    }

    this.messages.update((items) => [...items, toast]);
  }

  dismiss(id: number): void {
    const [toast] = this.messages().filter((item) => item.id === id);

    if (toast?.timeoutId && this.isBrowser) {
      window.clearTimeout(toast.timeoutId);
    }

    this.messages.update((items) => items.filter((item) => item.id !== id));
  }

  clear(): void {
    if (this.isBrowser) {
      this.messages().forEach((toast) => {
        if (toast.timeoutId) {
          window.clearTimeout(toast.timeoutId);
        }
      });
    }

    this.messages.set([]);
  }
}
